/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';
import type { VaccinationSchedules } from './VaccinationSchedules';
import {
    VaccinationSchedulesFromJSON,
    VaccinationSchedulesFromJSONTyped,
    VaccinationSchedulesToJSON,
} from './VaccinationSchedules';

/**
 * 
 * @export
 * @interface VaccinationSchedulesPagination
 */
export interface VaccinationSchedulesPagination {
    /**
     * 
     * @type {Array<VaccinationSchedules>}
     * @memberof VaccinationSchedulesPagination
     */
    data?: Array<VaccinationSchedules>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof VaccinationSchedulesPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the VaccinationSchedulesPagination interface.
 */
export function instanceOfVaccinationSchedulesPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VaccinationSchedulesPaginationFromJSON(json: any): VaccinationSchedulesPagination {
    return VaccinationSchedulesPaginationFromJSONTyped(json, false);
}

export function VaccinationSchedulesPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaccinationSchedulesPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(VaccinationSchedulesFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function VaccinationSchedulesPaginationToJSON(value?: VaccinationSchedulesPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(VaccinationSchedulesToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

